import type { ColumnLoader } from '@/core/tables/types'
import { defaultLoaderColumnConfig } from '@/composition/table/const'

export const getDefaultLoaderColumnsConfig = (): Array<ColumnLoader> => defaultLoaderColumnConfig
